<template>
  <el-dialog
    class="tips-dialog"
    :show-close="false"
    title="如何写出好文章"
    :visible.sync="flag"
    width="722px"
    center
  >
    <div>
      <p class="before-content-color title">
        <span class="before-icon"></span> 对患者有帮助
      </p>
      <p class="dialog-contents">
        能具体解决患者某个病程阶段或某个场景下的顾虑和担心（可参考门诊时患者常问的问题）
      </p>
    </div>
    <div>
      <p class="before-content-color title">
        <span class="before-icon"></span> 主题明确
      </p>
      <p class="dialog-contents">
        标题，患者一看就知道要讲什么；内容，阐述完整，并和标题强相关
      </p>
    </div>
    <div>
      <p class="before-content-color title">
        <span class="before-icon"></span> 易于理解
      </p>
      <p class="dialog-contents">
        段落清晰，表达通俗易懂，请避免搜索引擎百科式、或纯粹医学专业教科书式的科普内容
      </p>
    </div>
    <div slot="footer" class="dialog-footer btns dialog-but">
      <el-button type="primary" @click="$emit('handleClose')"
      >我知道了</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "articleTipDialog",
  props: ['articleTips'],
  computed: {
    flag: {
      get() {
        return this.articleTips
      },
      set(val) {
        this.$emit('update:articleTips',val)
      }
    }
  },
}
</script>

<style lang="scss" scoped>
@import "@/styles/dialog_common.scss";
.btns{
  padding-bottom: 22px;
  padding-top: 9px;
  line-height: 0px !important;
}
</style>
